const APIConfig =  {
  URL: 'https://r1chy5zeeh.execute-api.us-east-1.amazonaws.com/prod'
}

export default APIConfig